import {EntityDisplayEvent} from "../../../infrastructure/models/analytics/entity-display-event";

export class CompetitionsSliderEntityDisplayEvent extends EntityDisplayEvent {
  competitionId: Number;
  sportTypeId: Number;
  widgetType: String;
  partner: String;
  screenResolution: String;

  constructor(params) {
    super(params);

    this.competitionId = params.competitionId;
    this.sportTypeId = params.sportTypeId;
    this.widgetType = params.widgetType;
    this.partner = params.partner;
    this.screenResolution = params.screenResolution;
  }

  get properties() {
    const properties = super.properties;

    properties.competitionId = this.competitionId;
    properties.sportTypeId = this.sportTypeId;
    properties.widgetType = this.widgetType;
    properties.partner = this.partner;
    properties.screenResolution = this.screenResolution;

    return properties;
  }
}
